import { render, staticRenderFns } from "./ProductHeaderStandard.vue?vue&type=template&id=29267c6c"
import script from "./ProductHeaderStandard.vue?vue&type=script&lang=js"
export * from "./ProductHeaderStandard.vue?vue&type=script&lang=js"
import style0 from "./ProductHeaderStandard.vue?vue&type=style&index=0&id=29267c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports